import React from 'react';
import classNames from 'classnames';

import './Video.css';

const Video = (props) => {
  const classes = classNames('Video', props.className);

  return (
    <div className={classes}>
      <div className="embed-responsive embed-responsive-16by9 ">

        <iframe
          className="embed-responsive-item"
          src={props.src}
          title={props.title}
        />

      </div>
    </div>
  );
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/Video.js